export default "__VITE_ASSET__LSMPnMfh__"